import Link from 'next/link';
import React from 'react';

import { BreadcrumbsStructuredData } from '../StructuredData/BreadcrumbsStructuredData';

type Path = {
  path?: string;
  name: string;
};

interface Props {
  data: Path[];
}

const BreadcrumbsItem = (props: Path) => {
  const { name, path } = props;

  if (!path) {
    return <li className="text-nowrap text-body-s text-text-grey-standard">{name}</li>;
  }
  return (
    <>
      <li className="text-nowrap text-body-s text-text-grey-standard">
        <Link href={path}>{name}</Link>
      </li>
      <li aria-hidden="true" className="mx-2 text-body-s text-text-grey-standard">
        /
      </li>
    </>
  );
};

export const Breadcrumbs = (props: Props) => {
  const { data } = props;

  return (
    <>
      <BreadcrumbsStructuredData data={data} />
      <nav>
        <ol className="no-scrollbar flex flex-nowrap items-center overflow-auto">
          {data.map((item) => (
            <BreadcrumbsItem key={item.name} {...item} />
          ))}
        </ol>
      </nav>
    </>
  );
};
